import { useLayoutEffect, useRef, useState } from 'react';
import { placeTaskPreview } from '../tasks/taskPreview';
import { agendaPreviewLines, type AgendaTableRow } from '../../services/calendar/agendaTable';
import '../tasks/taskPreview.css';

function viewport() {
  return { width: window.innerWidth, height: window.innerHeight };
}

export function AgendaPreviewCard({
  row,
  anchor,
  shown,
}: {
  row: AgendaTableRow;
  anchor: DOMRect;
  shown: boolean;
}) {
  const ref = useRef<HTMLDivElement>(null);
  const lines = agendaPreviewLines(row);
  const [pos, setPos] = useState(() =>
    placeTaskPreview(anchor, { width: 320, height: 160 }, viewport()),
  );

  useLayoutEffect(() => {
    const node = ref.current;
    setPos(placeTaskPreview(
      anchor,
      { width: node?.offsetWidth || 320, height: node?.offsetHeight || 160 },
      viewport(),
    ));
  }, [anchor, row]);

  return (
    <div
      ref={ref}
      className={shown ? 'tp-preview is-on' : 'tp-preview'}
      style={{ left: pos.left, top: pos.top }}
      role="tooltip"
    >
      <div className="tp-head">
        <div className="tp-type">{row.typeLabel}</div>
      </div>
      <div className="tp-body">
        <div className="tp-title as-heading">{row.objet}</div>
        <div className="tp-gold" />
        <p className="tp-excerpt">{row.when}</p>
        {lines.map((line) => (
          <p key={line.label} className="tp-excerpt">
            <b>{line.label}.</b> {line.value}
          </p>
        ))}
      </div>
    </div>
  );
}
